export {
    StyledRoot as BaseboxRoot,
    StyledInput as BaseboxInput,
    StyledTrigger as BaseboxTrigger,
    StyledContent as BaseboxContent,
    StyledLabel as BaseboxLabel,
    StyledDescription as BaseboxDescription,
    StyledContentWrapper as BaseboxContentWrapper,
} from './Basebox';
export type { BaseboxProps } from './Basebox';
